import PageComponent from '../component/page-component';


class SlideshowNavigation extends PageComponent {
	constructor({
		root,
		element,
		navigationAttribute = 'goTo',
		handleSwipeAttribute = 'handleSwipe',
		currentClass = 'current',
		stopPropagation = true,
		capture = true
	}) {
		super({root: root, element: element});
		this.navigationAttribute = navigationAttribute;
		this.defaults.currentClass = currentClass;
		this.defaults.handleSwipeAttribute = handleSwipeAttribute;
		this.defaults.stopPropagation = stopPropagation;
		this.defaults.capture = capture;
	}


	prepare() {
		const data = this.dataAttr();
		this.currentClass = data.get('currentClass');
		this.handleSwipeAttribute = data.get('handleSwipeAttribute');
		this.stopPropagation = data.get('stopPropagation');
		this.capture = data.get('capture');
		this.slideshowIds = data.get('for', []);
		if (!Array.isArray(this.slideshowIds)) {
			this.slideshowIds = [this.slideshowIds];
		}
		let positionSet = false;
		if (this.slideshowIds.length) {
			this.slideshows = [];
			for (const id of this.slideshowIds) {
				const slideshow = this.components.queryComponent(this.root, this.dataSelector('id', id));
				if (slideshow) {
					const slideshowElement = slideshow.getElement();
					if (this.dataAttr(slideshowElement).get(this.handleSwipeAttribute, false)) {
						this.listeners['swipe' + id] = this.events.on(slideshowElement, 'swipe', this.onSwipe.bind(this));
					}
					if (!positionSet) {
						positionSet = true;
						this.listeners.beforeSwitch = this.events.on(slideshowElement, 'slideshow:beforeswitch', this.onBeforeSwitch.bind(this));

						// this should be already done in the markup, this is just to cover corner cases
						const currentSlide = slideshow.getCurrentSlide();
						if (currentSlide) {
							const index = currentSlide.getIndex();
							const triggers = this.element.querySelectorAll(this.dataSelector(this.navigationAttribute, index));
							for (const trigger of triggers) {
								this.classList(trigger).add(this.currentClass);
								trigger.setAttribute('aria-selected', 'true');
							}
						}
					}
					this.slideshows.push(slideshow);
				}
			}
			if (this.slideshows.length) {
				this.listeners.click = this.events.on(this.element, this.dataSelector(this.navigationAttribute), 'click', this.onClick.bind(this), {capture: this.capture});
			}
		}
	}


	onClick(event, target) {
		event.preventDefault();
		if (this.stopPropagation) {
			event.stopPropagation();
		}
		const index = this.dataAttr(target).get(this.navigationAttribute);
		for (const slideshow of this.slideshows) {
			switch (index) {
				case 'next':
					slideshow.next();
					break;
				case 'prev':
					slideshow.prev();
					break;
				default:
					slideshow.goTo(index);
			}
		}
	}


	onSwipe(event) {
		for (const slideshow of this.slideshows) {
			if (event.gesture.offsetDirection === this.events.gestures.DIRECTION_RIGHT) {
				slideshow.prev();
			} else {
				slideshow.next();
			}
		}
	}


	onBeforeSwitch(event) {
		if (!event.defaultPrevented) {
			const detail = event.detail;
			const currentSlide = detail.currentSlide;
			const newSlide = detail.newSlide;
			if (currentSlide) {
				const currentTriggers = this.element.querySelectorAll(this.dataSelector(this.navigationAttribute, currentSlide.getIndex()));
				for (const trigger of currentTriggers) {
					this.classList(trigger).remove(this.currentClass);
					trigger.setAttribute('aria-selected', 'false');
				}
			}
			if (newSlide) {
				const newTriggers = this.element.querySelectorAll(this.dataSelector(this.navigationAttribute, newSlide.getIndex()));
				for (const trigger of newTriggers) {
					this.classList(trigger).add(this.currentClass);
					trigger.setAttribute('aria-selected', 'true');
				}
			}
		}
	}
}

export default SlideshowNavigation;
